<template>
  <v-container>
    <v-card color="primary" class="rounded-xxl py-16 px-10">
      <v-card class="pt-7 pb-16" color="#fff">
        <v-row class="px-6">
          <v-col cols="12" md="6">
            <v-text-field
                @input="searchFunc"
                v-model="filterSearch.search"
                clearable
                class="rounded-lg pr-0 sm-font400-14"
                solo
                append-icon="mdi-magnify"
                placeholder="جستجو"
                single-line
                hide-details
            ></v-text-field>
          </v-col>


          <v-col cols="12" md="3">
            <v-btn
                block
                color="positive"
                :to="`/courses/class/users/add/${$route.params.id}`"
                class="white--text rounded-xl sm-font400-13"
                xelevation="2"
                height="48"
            >افزودن کاربر به دوره
            </v-btn>
          </v-col>
          <v-col cols="12" md="3">
            <v-btn
                block
                color="nagative"
                class="white--text rounded-xl sm-font400-13"
                @click="showDeleteModal = true"
                xelevation="2"
                height="48"
                :disabled="ids.length === 0"
            >
              حذف کاربر از دوره
            </v-btn>

          </v-col>
        </v-row>
        <v-row>
          <v-col md="5" cols="12">
            <div v-if="dataModel.title">
              <label>نام دوره:</label>
              <label>{{ dataModel.title }}</label>
            </div>
            <div v-if="dataModel.teachers_data[0]">
              <label>نام مربی:</label>
              <label>{{ dataModel.teachers_data[0].first_name }} {{ dataModel.teachers_data[0].last_name }}</label>
            </div>
          </v-col>
          <v-col md="4" cols="12">
            <div v-if="dataModel.event_time">
              <label>ساعت برگزاری:</label>
              <label>{{ dataModel.event_time }}</label>
            </div>
            <div v-if="dataModel.capacity">
              <label>تعداد افراد:</label>
              <label>{{ dataModel.capacity - dataModel.remaining_capacity }}</label>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <v-btn
                block
                outlined
                @click="exportExcel"
                class="thirdColor--text rounded-lg sm-font400-13"
                height="56"
            >
              <v-icon>mdi-upload</v-icon>
              خروجی اکسل
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-data-table
                class="sm-font400-13 textTable--text"
                :headers="headers"
                :items="items"
                hide-default-footer
                no-results-text="دیتایی وجود ندارد!"
                :loading="loading"
                loading-text="Loading..."
                item-key="id"
                show-select
                v-model="ids"
            >
              <template v-slot:[`item.image`]="{ item }">
                <img
                    width="32"
                    height="32"
                    v-if="item.image"
                    :src="item.image"
                    class="ml-2 rounded-circle"
                    alt=""
                />
              </template>
              <template v-slot:[`item.username`]="{ item }">
                <div>{{ item.first_name }} {{ item.last_name }}</div>
              </template>
            </v-data-table>
            <v-pagination v-model="filterSearch.page" :length="totalPages" @input="changePage"
                          color="thirdColor"></v-pagination>
          </v-col>
        </v-row>
      </v-card>

    </v-card>

    <v-dialog v-model="showDeleteModal" width="500">
      <v-card class="pa-10 text-center">
        <h3 class="mb-5">آیا از حذف مطمئن هستید؟</h3>
        <div class="text-center">
          <v-btn width="130" height="48" color="gray" outlined class="me-2 rounded-xl" @click="showDeleteModal = false">
            بازگشت
          </v-btn>
          <v-btn @click="deleteItem" width="130" height="48" class="white--text rounded-xl" color="primary">حذف کاربر
          </v-btn>
        </div>

      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import courses from "@/Services/modules/courses";
import courseApi from "@/Services/modules/courses";

export default {
  name: "userList",
  data() {
    return {
      headers: [
        {text: "پروفایل", value: "image"},
        {text: "نام و نام‌ خانوادگی", value: "username"},
        {text: "ایمیل", value: "email"},
        {text: "شماره تماس", value: "phone_number"},
      ],
      totalPages: 1,
      loading: false,
      items: [],
      dataModel: {},
      ids: [],
      showDeleteModal: false,
      filterSearch: {
        page: Number(this.$route.query.page) || 1,
        search: this.$route.query.search || "",
      },
    }
  },
  mounted() {
    this.getClassData()
    this.getData()

  },
  methods: {
    getClassData() {
      courseApi.getClassById(this.$route.params.id).then(res => {
        this.dataModel = res.data
      })
    },
    getData() {
      this.loading = true
      courses.getClassStudents(this.$route.params.id, {...this.filterSearch}).then(res => {
        this.items = res.data.results
        this.totalPages = res.data.page_count
      }).finally(() => {
        this.loading = false
      })
    },
    exportExcel() {
      courseApi.getStudentsClassExcel(this.$route.params.id).then((response) => {
        window.open(URL.createObjectURL(response.data));
      })
    },
    deleteItem() {
      this.showDeleteModal = true;
      let ids = [];
      this.ids.forEach((item) => {
        ids.push(item.id);
      });
      courses.deleteUserFromCourses(this.$route.params.id, ids).then(() => {
        this.getData(this.filterSearch);
        this.showDeleteModal = false;
        this.ids = []
      });
    },
    searchFunc() {
      this.$router.push({
        query: {
          ...this.$route.query,
          search: this.filterSearch.search
        }
      })
      this.getData()
    },
    changePage() {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: this.filterSearch.page
        }
      })
      this.getData()
    },
  }
}
</script>
<style scoped>

</style>
